/**
 * Client-side JWT token storage utilities
 * Handles secure storage and retrieval of ap-portal-token
 */

const TOKEN_KEY = 'ap-portal-token'

export const setApPortalToken = (token: string): void => {
  if (typeof window === 'undefined') {
    console.warn('Token storage only available on client side')
    return
  }

  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch (error) {
    console.error('Failed to store JWT token:', error)
  }
}

export const getApPortalToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const token = localStorage.getItem(TOKEN_KEY)
    return token
  } catch (error) {
    console.error('Failed to retrieve JWT token:', error)
    return null
  }
}

export const hasValidApPortalToken = (): boolean => {
  return getApPortalToken() !== null
}

export const clearApPortalToken = (): void => {
  if (typeof window === 'undefined') {
    console.warn('Token storage only available on client side')
    return
  }

  try {
    localStorage.removeItem(TOKEN_KEY)
    console.log('✅ JWT token cleared successfully')
  } catch (error) {
    console.error('Failed to clear JWT token:', error)
  }
}
